import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from "react";
import HomePage from "./pages/HomePage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Reserva from "./pages/Reserva";
import Contato from "./pages/Contato";
import AdminHome from "./pages/AdminHome";
import AdminAcomodacao from "./pages/AdminAcomodacoes";
import AdminReserva from "./pages/AdminReserva";
import AdminUsuario from "./pages/AdminUsuario";
import AdminHospede from "./pages/AdminHospede";
import AdminRelatorios from "./pages/AdminRelatorios";
import UsuarioDados from "./pages/UsuarioDados";
import UsuarioPainel from "./pages/UsuarioPainel";
import PreCheckIn from "./pages/PreCheckIn";
import Pagamento from "./pages/Pagamento";
import LandingPage from "./pages/LandingPage";

import { initMercadoPago } from "@mercadopago/sdk-react";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

initMercadoPago(process.env.REACT_APP_MP_PUBLIC_KEY, {
  locale: "pt-BR",
});

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<LandingPage />} />
        {/* <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reservas" element={<Reserva />} />
        <Route path="/contato" element={<Contato />} />
        <Route path="/admin" element={<AdminHome />} />
        <Route path="/admin/reservas" element={<AdminReserva />} />
        <Route path="/admin/usuarios" element={<AdminUsuario />} />
        <Route path="/admin/hospedes" element={<AdminHospede />} />
        <Route path="/admin/acomodacoes" element={<AdminAcomodacao />} />
        <Route path="/admin/relatorios" element={<AdminRelatorios />} />
        <Route path="/usuario/dados" element={<UsuarioDados />} />
        <Route path="/usuario/painel" element={<UsuarioPainel />} />
        <Route path="/precheckin/:id" element={<PreCheckIn />} />
        <Route path="/pagamento" element={<Pagamento />} />
        */}
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </BrowserRouter>
  );
}

export default App;
